export const INTEGRATIONS_PANEL_FACT = {
  Account: 'account_label',
  ConnectionType: 'connection_type',
  LastChecked: 'last_checked_at',
}

export const INTEGRATIONS_PANEL_FACTS = [
  {
    labelKey: 'RentalPortal.IntegrationsPanelAccountKey',
    name: INTEGRATIONS_PANEL_FACT.Account,
  },
  {
    labelKey: 'RentalPortal.IntegrationsPanelConnectionTypeKey',
    name: INTEGRATIONS_PANEL_FACT.ConnectionType,
  },
  {
    labelKey: 'RentalPortal.IntegrationsLastCheckedColumnKey',
    name: INTEGRATIONS_PANEL_FACT.LastChecked,
  },
]

export const QA_NAME_INTEGRATIONS_PANEL_TITLE =
  'rentalPortalIntegrationsPanelTitle'

export const QA_NAME_INTEGRATIONS_PANEL_STATUS =
  'rentalPortalIntegrationsPanelStatus'

export const QA_NAME_INTEGRATIONS_PANEL_FACT =
  'rentalPortalIntegrationsPanelFact'
